import React from "react";
import { CheckCircle2 } from "lucide-react";

export const FormStatus = ({ status }) => {
  if (status.state === "success") {
    return (
      <div
        data-testid="form-success"
        className="flex items-start gap-2.5 bg-emerald-50 border-l-4 border-emerald-500 text-emerald-900 p-4 text-sm"
      >
        <CheckCircle2 className="w-5 h-5 flex-shrink-0 mt-0.5" strokeWidth={2.2} />
        <span>{status.msg}</span>
      </div>
    );
  }
  if (status.state === "error") {
    return (
      <div
        data-testid="form-error"
        className="bg-red-50 border-l-4 border-red-500 text-red-900 p-4 text-sm"
      >
        {status.msg}
      </div>
    );
  }
  return null;
};
